import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/jobs/jobsSlice";
import Loading from "../UI/Loading";
import JobItem from "./JobItem";

const JobList = () => {
    const dispatch = useDispatch();

    const { jobs, isLoading, isError, error } = useSelector(
        (state) => state.jobs
    );

    const { type, text, sort } = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchJobs(text));
    }, [dispatch, text]);

    const filterByType = (item) => {
        switch (type) {
            case "Internship":
                return item.type === "Internship";
            case "Full Time":
                return item.type === "Full Time";
            case "Remote":
                return item.type === "Remote";
            default:
                return item;
        }
    };

    const sortBySalary = (a, b) => {
        switch (sort) {
            case "Salary (Low to High)":
                return +a.salary - +b.salary;
            case "Salary (High to Low)":
                return +b.salary - +a.salary;
            default:
                return;
        }
    };

    // decide what to render
    let content;

    if (isLoading) content = <Loading />;

    if (!isLoading && isError)
        content = (
            <div className="col-span-12" style={{ color: "white" }}>
                {error}
            </div>
        );

    if (!isError && !isLoading && jobs?.length === 0) {
        content = (
            <div className="col-span-12" style={{ color: "white" }}>
                No jobs found!
            </div>
        );
    }

    if (!isError && !isLoading && jobs?.length > 0) {
        content = jobs
            .slice()
            .sort(sortBySalary)
            .filter(filterByType)
            .map((job) => <JobItem key={job.id} job={job} />);
    }

    return <div className="jobs-list">{content}</div>;
};

export default JobList;
